import * as yup from "yup";
import { getStringRequiredFieldMessage } from "@shared/utils/yup-extensions";

export const SUPPORT_DESCRIPTION_MAX_LENGTH = 1500;

export const supportThreadFormSchema = yup
  .object({
    numberOfMessages: yup
      .number()
      .min(5)
      .required()
      .label("Number of messages"),
    description: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .max(SUPPORT_DESCRIPTION_MAX_LENGTH)
      .required()
      .label("Description"),
  })
  .required();

export const supportGeneralFormSchema = yup
  .object({
    description: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .max(SUPPORT_DESCRIPTION_MAX_LENGTH)
      .required()
      .label("Description"),
  })
  .required();

export const SUPPORT_THREAD_SCHEMA_DEFAULT_VALUES: SupportThreadFormSchema = {
  description: "",
  numberOfMessages: 20,
};

export const SUPPORT_GENERAL_SCHEMA_DEFAULT_VALUES: SupportGeneralFormSchema = {
  description: "",
};

export type SupportThreadFormSchema =
  typeof supportThreadFormSchema.__outputType;

export type SupportGeneralFormSchema =
  typeof supportGeneralFormSchema.__outputType;
